import { render } from "./MeetingSummaries.vue?vue&type=template&id=1e48d37c"
import script from "./MeetingSummaries.vue?vue&type=script&lang=js"
export * from "./MeetingSummaries.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__